export const emoji = {
  "微笑": {
    "code": "/::)",
    "icon": "smiley_05f15f9.png"
  },
  "撇嘴": {
    "code": "/::~",
    "icon": "smiley_15f15f9.png"
  },
  "色": {
    "code": "/::B",
    "icon": "smiley_25f15f9.png"
  },
  "发呆": {
    "code": "/::|",
    "icon": "smiley_35f15f9.png"
  },
  "得意": {
    "code": "/:8-)",
    "icon": "smiley_45f15f9.png"
  },
  "流泪": {
    "code": "/::<",
    "icon": "smiley_55f15f9.png"
  },
  "害羞": {
    "code": "/::$",
    "icon": "smiley_65f15f9.png"
  },
  "闭嘴": {
    "code": "/::X",
    "icon": "smiley_75f15f9.png"
  },
  "睡": {
    "code": "/::Z",
    "icon": "smiley_85f15f9.png"
  },
  "大哭": {
    "code": "/::'(",
    "icon": "smiley_95f15f9.png"
  },
  "尴尬": {
    "code": "/::-|",
    "icon": "smiley_105f15f9.png"
  },
  "发怒": {
    "code": "/::@",
    "icon": "smiley_115f15f9.png"
  },
  "调皮": {
    "code": "/::P",
    "icon": "smiley_125f15f9.png"
  },
  "呲牙": {
    "code": "/::D",
    "icon": "smiley_135f15f9.png"
  },
  "惊讶": {
    "code": "/::O",
    "icon": "smiley_145f15f9.png"
  },
  "难过": {
    "code": "/::(",
    "icon": "smiley_155f15f9.png"
  },
  "囧": {
    "code": "/:--b",
    "icon": "smiley_175f15f9.png"
  },
  "抓狂": {
    "code": "/::Q",
    "icon": "smiley_185f15f9.png"
  },
  "吐": {
    "code": "/::T",
    "icon": "smiley_195f15f9.png"
  },
  "偷笑": {
    "code": "/:,@P",
    "icon": "smiley_205f15f9.png"
  },
  "愉快": {
    "code": "/:,@-D",
    "icon": "smiley_215f15f9.png"
  },
  "白眼": {
    "code": "/::d",
    "icon": "smiley_225f15f9.png"
  },
  "傲慢": {
    "code": "/:,@o",
    "icon": "smiley_235f15f9.png"
  },
  "困": {
    "code": "/:|-)",
    "icon": "smiley_255f15f9.png"
  },
  "惊恐": {
    "code": "/::!",
    "icon": "smiley_265f15f9.png"
  },
  "流汗": {
    "code": "/::L",
    "icon": "smiley_275f15f9.png"
  },
  "憨笑": {
    "code": "/::>",
    "icon": "smiley_285f15f9.png"
  },
  "悠闲": {
    "code": "/::,@",
    "icon": "smiley_295f15f9.png"
  },
  "奋斗": {
    "code": "/:,@f",
    "icon": "smiley_305f15f9.png"
  },
  "咒骂": {
    "code": "/::-S",
    "icon": "smiley_315f15f9.png"
  },
  "疑问": {
    "code": "/:?",
    "icon": "smiley_325f15f9.png"
  },
  "嘘": {
    "code": "/:,@x",
    "icon": "smiley_335f15f9.png"
  },
  "晕": {
    "code": "/:,@@",
    "icon": "smiley_345f15f9.png"
  },
  "衰": {
    "code": "/:,@!",
    "icon": "smiley_365f15f9.png"
  },
  "骷髅": {
    "code": "/:!!!",
    "icon": "smiley_375f15f9.png"
  },
  "敲打": {
    "code": "/:xx",
    "icon": "smiley_385f15f9.png"
  },
  "再见": {
    "code": "/:bye",
    "icon": "smiley_395f15f9.png"
  },
  "擦汗": {
    "code": "/:wipe",
    "icon": "smiley_405f15f9.png"
  },
  "抠鼻": {
    "code": "/:dig",
    "icon": "smiley_415f15f9.png"
  },
  "鼓掌": {
    "code": "/:handclap",
    "icon": "smiley_425f15f9.png"
  },
  "坏笑": {
    "code": "/:B-)",
    "icon": "smiley_445f15f9.png"
  },
  "左哼哼": {
    "code": "/:<@",
    "icon": "smiley_455f15f9.png"
  },
  "右哼哼": {
    "code": "/:@>",
    "icon": "smiley_465f15f9.png"
  },
  "哈欠": {
    "code": "/::-O",
    "icon": "smiley_475f15f9.png"
  },
  "鄙视": {
    "code": "/:>-|",
    "icon": "smiley_485f15f9.png"
  },
  "委屈": {
    "code": "/:P-(",
    "icon": "smiley_495f15f9.png"
  },
  "快哭了": {
    "code": "/::'|",
    "icon": "smiley_505f15f9.png"
  },
  "阴险": {
    "code": "/:X-)",
    "icon": "smiley_515f15f9.png"
  },
  "亲亲": {
    "code": "/::*",
    "icon": "smiley_525f15f9.png"
  },
  "可怜": {
    "code": "/:8*",
    "icon": "smiley_545f15f9.png"
  },
  "笑脸": {
    "code": "[Happy]",
    "icon": "u1F6045f15f9.png"
  },
  "生病": {
    "code": "[Sick]",
    "icon": "u1F6375f15f9.png"
  },
  "破涕为笑": {
    "code": "[Lol]",
    "icon": "u1F6025f15f9.png"
  },
  "脸红": {
    "code": "[Flushed]",
    "icon": "u1F6335f15f9.png"
  },
  "恐惧": {
    "code": "[Terror]",
    "icon": "u1F6315f15f9.png"
  },
  "失望": {
    "code": "[LetDown]",
    "icon": "u1F6145f15f9.png"
  },
  "无语": {
    "code": "[Duh]",
    "icon": "u1F6125f15f9.png"
  },
  "嘿哈": {
    "code": "[Hey]",
    "icon": "2_045f15f9.png"
  },
  "捂脸": {
    "code": "[Facepalm]",
    "icon": "2_055f15f9.png"
  },
  "奸笑": {
    "code": "[Smirk]",
    "icon": "2_025f15f9.png"
  },
  "机智": {
    "code": "[Smart]",
    "icon": "2_065f15f9.png"
  },
  "皱眉": {
    "code": "[Concerned]",
    "icon": "2_125f15f9.png"
  },
  "耶": {
    "code": "[Yeah!]",
    "icon": "2_115f15f9.png"
  },
  "吃瓜": {
    "code": "[Onlooker]",
    "icon": "Watermelon5f15f9.png"
  },
  "加油": {
    "code": "[GoForIt]",
    "icon": "Addoil5f15f9.png"
  },
  "汗": {
    "code": "[Sweats]",
    "icon": "Sweat5f15f9.png"
  },
  "天啊": {
    "code": "[OMG]",
    "icon": "Shocked5f15f9.png"
  },
  "Emm": {
    "code": "[Emm]",
    "icon": "Cold5f15f9.png"
  },
  "社会社会": {
    "code": "[Respect]",
    "icon": "Social5f15f9.png"
  },
  "旺柴": {
    "code": "[Doge]",
    "icon": "Yellowdog5f15f9.png"
  },
  "好的": {
    "code": "[NoProb]",
    "icon": "NoProb5f15f9.png"
  },
  "打脸": {
    "code": "[MyBad]",
    "icon": "Slap5f15f9.png"
  },
  "加油加油": {
    "code": "[KeepFighting]",
    "icon": "KeepFighting5f15f9.png"
  },
  "哇": {
    "code": "[Wow]",
    "icon": "Wow5f15f9.png"
  },
  "翻白眼": {
    "code": "[Boring]",
    "icon": "Boring5f15f9.png"
  },
  "Awesome": {
    "code": "[666]",
    "icon": "Awesome5f15f9.png"
  },
  "让我看看": {
    "code": "[LetMeSee]",
    "icon": "LetMeSee5f15f9.png"
  },
  "叹气": {
    "code": "[Sigh]",
    "icon": "Sigh5f15f9.png"
  },
  "苦涩": {
    "code": "[Hurt]",
    "icon": "Hurt5f15f9.png"
  },
  "裂开": {
    "code": "[Broken]",
    "icon": "Broken5f15f9.png"
  },
  "嘴唇": {
    "code": "/:showlove",
    "icon": "smiley_655f15f9.png"
  },
  "爱心": {
    "code": "/:heart",
    "icon": "smiley_665f15f9.png"
  },
  "心碎": {
    "code": "/:break",
    "icon": "smiley_675f15f9.png"
  },
  "拥抱": {
    "code": "/:hug",
    "icon": "smiley_785f15f9.png"
  },
  "强": {
    "code": "/:strong",
    "icon": "smiley_795f15f9.png"
  },
  "弱": {
    "code": "/:weak",
    "icon": "smiley_805f15f9.png"
  },
  "握手": {
    "code": "/:share",
    "icon": "smiley_815f15f9.png"
  },
  "胜利": {
    "code": "/:v",
    "icon": "smiley_825f15f9.png"
  },
  "抱拳": {
    "code": "/:@)",
    "icon": "smiley_835f15f9.png"
  },
  "勾引": {
    "code": "/:jj",
    "icon": "smiley_845f15f9.png"
  },
  "拳头": {
    "code": "/:@@",
    "icon": "smiley_855f15f9.png"
  },
  "OK": {
    "code": "/:ok",
    "icon": "smiley_895f15f9.png"
  },
  "合十": {
    "code": "[Worship]",
    "icon": "u1F64F.05f15f9.png"
  },
  "西瓜": {
    "code": "/:<W>",
    "icon": "smiley_565f15f9.png"
  },
  "啤酒": {
    "code": "/:beer",
    "icon": "smiley_575f15f9.png"
  },
  "咖啡": {
    "code": "/:coffee",
    "icon": "smiley_605f15f9.png"
  },
  "蛋糕": {
    "code": "/:cake",
    "icon": "smiley_685f15f9.png"
  },
  "玫瑰": {
    "code": "/:rose",
    "icon": "smiley_635f15f9.png"
  },
  "凋谢": {
    "code": "/:fade",
    "icon": "smiley_645f15f9.png"
  },
  "菜刀": {
    "code": "/:pd",
    "icon": "smiley_555f15f9.png"
  },
  "炸弹": {
    "code": "/:bome",
    "icon": "smiley_705f15f9.png"
  },
  "便便": {
    "code": "/:shit",
    "icon": "smiley_745f15f9.png"
  },
  "月亮": {
    "code": "/:moon",
    "icon": "smiley_755f15f9.png"
  },
  "太阳": {
    "code": "/:sun",
    "icon": "smiley_765f15f9.png"
  },
  "庆祝": {
    "code": "[Party]",
    "icon": "u1F3895f15f9.png"
  },
  "礼物": {
    "code": "/:gift",
    "icon": "u1F3815f15f9.png"
  },
  "红包": {
    "code": "[Packet]",
    "icon": "2_095f15f9.png"
  },
  "發": {
    "code": "[Rich]",
    "icon": "2_165f15f9.png"
  },
  "福": {
    "code": "[Blessing]",
    "icon": "2_155f15f9.png"
  },
  "猪头": {
    "code": "/:pig",
    "icon": "smiley_625f15f9.png"
  },
  "烟花":{
      "code":"[Fireworks]",
      "icon": "Fireworks.png"
  },
  "爆竹":{
      "code":"[爆竹]",
      "icon": "爆竹.png"
  },
  "跳跳": {
    "code": "/:jump",
    "icon": "smiley_925f15f9.png"
  },
  "发抖": {
    "code": "/:shake",
    "icon": "smiley_935f15f9.png"
  },
  "怄火": {
    "code": "/:<O>",
    "icon": "smiley_945f15f9.png"
  },
  "转圈": {
    "code": "/:circle",
    "icon": "smiley_955f15f9.png"
  }
}


// WEBPACK FOOTER //
// ./src/pages/webot/emoji/emoji.js